import React from 'react';
import styled from 'styled-components';
import { Headline, Body } from '../../../../components/Typography';
import ConfirmButton from '../../OrderSettingModal/components/ConfirmButton';
import UnavailableMessage from '../../OrderSettingModal/components/UnavailableMessage';
import {
  renderMessageText,
  orderingIsAvailable,
} from '../../OrderSettingModal/utils/helper';
import { getOpeningHour } from '../../utils/helper';
import appConfig from '../../../../../app-config';
import { DROPOFF } from '../../orderSettingTypes';

const Wrapper = styled.div`
  padding: 20px 18px 20px 13px;
  border-radius: 9.6px;
  box-shadow: 0 5px 16px 0 rgba(20, 19, 33, 0.12);
  background-color: #fff;
  margin-bottom: 18px;
  align-items: center;
  cursor: pointer;
  border: 2px solid
    ${(props) =>
      props.isCurrentStore ? props.theme.primaryButtonBackgroundColor : 'none'};
  min-height: 170px;
  max-width: 500px;
  :hover {
    box-shadow: 0 2px 7px 0 rgba(20, 19, 33, 0.24);
  }
  display: grid;
`;

const MainContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-gap: 10px;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const InformationDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  text-align: left;
`;

const SecondColumn = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 100%;
`;

const ButtonDiv = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
`;

const LocationAddress = styled(Body)`
  margin-top: 9px;
`;

const ThresholdFeeText = styled(Body)`
  color: ${(props) => props.theme.primaryButtonFontColor};
`;

const ImageDiv = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
`;

const LocationPickupCard = ({
  location,
  isCurrentStore,
  interOrderType,
  setPickUpTimeFormIsVisible,
  resetInterSelectedDateTime,
}) => {
  const openingHour =
    location && location.hours ? getOpeningHour(location) : null;

  const orderingIsAvailableResult =
    location && location.ordering_hours
      ? orderingIsAvailable(location, location.ordering_hours)
      : null;
  const confirmButtonText = isCurrentStore
    ? 'Confirm'
    : location.is_order_ahead_enabled && orderingIsAvailableResult
    ? 'Order Here'
    : 'See Menu';

  return location ? (
    <Wrapper isCurrentStore={isCurrentStore}>
      <MainContent
        data-cy={`marketplace-pickup-location-card-${location?.name}`}
        onClick={() => {
          resetInterSelectedDateTime();
          setPickUpTimeFormIsVisible(true, location);
        }}
      >
        <ImageDiv>
          <img width="100" height="100" src={location.image_url} />
        </ImageDiv>
        <InformationDiv>
          <Headline>{location.name}</Headline>
          <LocationAddress>
            {location.line1}, {location.city}
          </LocationAddress>
          {!location.is_order_ahead_enabled || !location.accepting_orders ? (
            <Body>💤 Closed</Body>
          ) : openingHour && location.accepting_orders ? (
            <Body>Order until {openingHour} </Body>
          ) : null}
        </InformationDiv>
        <SecondColumn>
          <ButtonDiv>
            <ConfirmButton
              text={confirmButtonText}
              style={{
                borderRadius: '18px',
                minWidth: '110px',
                fontSize: '14px',
              }}
              inverted={
                confirmButtonText.toLowerCase().includes('here') ? false : true
              }
              onClick={() => {
                resetInterSelectedDateTime();
                setPickUpTimeFormIsVisible(true, location);
              }}
            />
          </ButtonDiv>
        </SecondColumn>
      </MainContent>
      {!location.is_order_ahead_enabled ? (
        <UnavailableMessage
          title="Selected location is unable to accept orders at the moment"
          marginTop="15px"
        />
      ) : !orderingIsAvailableResult || !location.accepting_orders ? (
        <UnavailableMessage
          marginTop="15px"
          title={renderMessageText(interOrderType, location.ordering_hours, [])}
        />
      ) : !location ? (
        <UnavailableMessage
          marginTop="15px"
          title={
            location.errorMessage || 'We are unable to deliver to this address'
          }
        />
      ) : null}
    </Wrapper>
  ) : null;
};

export default LocationPickupCard;
